<template>
  <div :class="{'tags-nav': true, 'tags-nav-new': isNewVersion}">
    <div id="tags" class="tags" ref="scrollArea" @mousewheel="handleScroll" @DOMMouseScroll="handleScroll" :style="{left: scrollLeft + 'px'}">
      <div class="tags-inner">
        <template v-if="isNewVersion">
            <Tag v-for="tag in tags"
                 type="dot"
                 closable
                 :color="tag.name===activeTag.name?'blue':'gray'"
                 :key="tag.name"
                 @click.native="handleSwitchTag(tag)">
                 {{generateTitle(tagName(tag))}}
                 <md-icon @click.native="handleTagClose(tag)" class="md-icon-close" name="close"></md-icon>
            </Tag>
        </template>
        <template v-else>
            <Tag v-for="tag in tags" type="dot" closable :color="tag.name===activeTag.name?'blue':'gray'" :key="tag.name"
              @on-close.stop="handleTagClose(tag)" @click.native="handleSwitchTag(tag)">{{generateTitle(tagName(tag))}}</Tag>
        </template>
      </div>
    </div>
    <div class="more">
      <Dropdown trigger="click" style="margin: 4px 10px;" @on-click="handleMoreTagsClick" placement="bottom-end">
        <a href="javascript:void(0)" style="color: #495060">
          {{staticRoutes?'所有标签':$t('components.tagsNav.allTags')}}
          <Icon type="arrow-down-b"></Icon>
        </a>
        <DropdownMenu slot="list">
          <DropdownItem v-for="tag in tags" :key="tag.name" :name="tag.name" :selected="tag.name===activeTag.name">{{tagName(tag)}}</DropdownItem>
          <DropdownItem divided name="closeAll">{{staticRoutes?'关闭所有':$t('components.tagsNav.closeAll')}}</DropdownItem>
        </DropdownMenu>
    </Dropdown>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { generateTitle } from '@/utils/index';
import Vue from 'vue';

export default {
  props: {
    staticRoutes: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scrollLeft: 10,
      tagCopy: [],
    };
  },
  computed: {
    ...mapGetters(['tags', 'activeTag', 'authority', 'isNewVersion']),
  },
  mounted() {
    this.$store.dispatch('openTag', this.$route);
    Vue.prototype.$closeTab = (tag) => {
        this.handleTagClose(tag);
    }
    Vue.prototype.$closeTabExcludeSwitch = () => {
        this.closeTabExcludeSwitch();
    }
  },
  methods: {
	/* 关闭除运维切换以外的页签 */
    closeTabExcludeSwitch() {
        this.tagCopy = this.tags.filter((item) => item.name !== 'switchingOperations');
        this.tagCopy.forEach((item, index) => {
            setTimeout(() => {
                this.handleTagClose(item);
            }, index * 10);
        });
    },
    generateTitle: generateTitle,
    handleTagClose(tag) {
      this.$store.dispatch('closeTag', tag);
      this.scrollLeft = 10;
      let lastTag = this.tags.slice(-1)[0];
      if (lastTag) {
        this.$router.push({
            name: lastTag.name,
            query: lastTag.query
        });
      } else {
        this.$router.push('/');
      }
    },
    handleSwitchTag(tag) {
      this.$store.dispatch('switchTag', tag);
      this.$router.push({
        name: tag.name,
        query: tag.query,
        params: tag.params
      });
    },
    handleMoreTagsClick(name) {
      if (name === 'closeAll') {
        this.$store.dispatch('closeAllTags');
        this.scrollLeft = 10;
      } else {
        const tag = this.tags.filter(item => item.name === name);
        if (tag.length > 0) {
          this.handleSwitchTag(tag[0]);
        }
      }
    },
    tagName(tag) {
      if (this.staticRoutes) {
        return this.$t(tag.meta.title);
      }
      // return this.getMenuName(tag, this.authority) || this.$t(tag.meta.title);
      return this.$t(tag.meta.title);
    },
    getMenuName(tag, menus) {
      for (let i = 0; i < menus.length; i += 1) {
        if (menus[i].fdKey === tag.name) {
          return menus[i].fdName;
        }
      }
      for (let i = 0; i < menus.length; i += 1) {
        if (menus[i].subNodes.length) {
          const res = this.getMenuName(tag, menus[i].subNodes);
          if (res) return res;
        }
      }
      return null;
    },
    handleScroll(e) {
      e = e || window.event;
      const upScroll = (e.wheelDelta && e.wheelDelta > 0) || (e.detail && e.detail < 0);
      const parentWidth = document.body.clientWidth - 300;
      const childWidth = this.$refs.scrollArea.clientWidth;
      if (childWidth > parentWidth) {
        if (upScroll) {
          if (this.scrollLeft + 150 >= 10) {
            this.scrollLeft = 10;
          } else {
            this.scrollLeft += 150;
          }
        } else if (this.scrollLeft - 150 <= parentWidth - childWidth) {
          this.scrollLeft = parentWidth - childWidth;
        } else {
          this.scrollLeft -= 150;
        }
      }
    },
  },
  watch: {
    $route(to) {
      if (this.tags.filter(item => item.name === to.name).length === 0) {
        this.$store.dispatch('openTag', to);
      } else {
        this.$store.dispatch('switchTag', to);
      }
    },
    tags(val) {
      if (!val.length) {
        this.$router.push('/');
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import './index.less';
</style>
